import axios from "axios";
import api from "@/plugins/api";
const ENDPOINT = "/portal/workspace/locale";
/**
 * Fetches the caller's workspace locale. Returns null when the BFF knows no client for the
 * tenant (404); any other failure propagates to the caller.
 */
export async function getWorkspaceLocale() {
    try {
        const response = await api.get(ENDPOINT, {
            unwrapEnvelope: true,
        });
        return {
            country: response.data.country ?? null,
            locale: response.data.locale,
            currency: response.data.currency ?? null,
        };
    }
    catch (error) {
        if (axios.isAxiosError(error) && error.response?.status === 404) {
            return null;
        }
        throw error;
    }
}
